<template>
    <button class="text-white rounded font-bold transition enabled:hover:scale-110 enabled:active:scale-100 enabled:active:brightness-[0.65] disabled:opacity-50" :class="classes">
        <slot></slot>
    </button>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    appearance: String,
    size: String
});

const isPrimary = computed(() => props.appearance == 'primary');
const isLarge = computed(() => props.size == 'large');

const classes = computed(() => ({
    'bg-dark-gray': !isPrimary.value,
    'bg-gradient-to-r': isPrimary.value,
    'from-purple': isPrimary.value,
    'to-blue': isPrimary.value,

    'uppercase': isLarge.value,
    'px-12': isLarge.value,
    'py-2': isLarge.value,
    'text-2xl': isLarge.value,
    'py-1': !isLarge.value,
    'px-2': !isLarge.value
}));
</script>